export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export type AUTHENTICATE_USER = typeof AUTHENTICATE_USER;

export const SET_ALREADY_SUBMITTED_STATE = 'SET_ALREADY_SUBMITTED_STATE';
export type SET_ALREADY_SUBMITTED_STATE = typeof SET_ALREADY_SUBMITTED_STATE;

export const SET_CONNECTING_STATUS = 'SET_CONNECTING_STATUS';
export type SET_CONNECTING_STATUS = typeof SET_CONNECTING_STATUS;

export const SET_VALID_LOGIN_STATUS = 'SET_VALID_LOGIN_STATUS';
export type SET_VALID_LOGIN_STATUS = typeof SET_VALID_LOGIN_STATUS;

export const SET_COMMUNICATION_ERROR_STATUS = 'SET_COMMUNICATION_ERROR_STATUS';
export type SET_COMMUNICATION_ERROR_STATUS = typeof SET_COMMUNICATION_ERROR_STATUS;



// WEBPACK FOOTER //
// ./src/store/Login/constants.ts